<template>
  <div>
    <div>Bienvenue,</div>
    <div>
      Votre interface dédiée vous permet de valider les inscription des participants à la XGTV. Vous pouvez
      consulter les inscriptions en attente de validation, en attente de réception de document ainsi que celles que vous
      avez déjà validées.
    </div>

    <div class="text-h6 mt-4">En attente de validation</div>
    <div>
      Il y a <b>{{ inscrits_to_validate.to_validate.length }} participant(s)</b> en attente de validation.
    </div>

    <v-table density="compact" v-if="inscrits_to_validate.to_validate.length > 0">
      <thead>
        <tr>
          <th class="text-left">Nom</th>
          <th class="text-left">Parcours</th>
          <th class="text-left">Fiche de renseignement médicale</th>
          <th class="text-left">CV Sportif</th>
          <th class="text-left">Certificat médical</th>
          <th class="text-left">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in inscrits_to_validate.to_validate" :key="item.id">
          <td>{{ item.nom }} {{ item.prenom }}</td>
          <td>{{ item.course.nom.replace("Expérience Grande Traversée Volcanique", "XGTV") }}</td>
          <td>
            <a :href="item.champs.fiche_medicale_xgtv" target="_blank"><v-btn elevation="0" color="primary-dark"
                density="compact">Consulter</v-btn></a>
          </td>
          <td>
            <a :href="item.champs.cv_sportif_xgtv" target="_blank"><v-btn elevation="0" color="primary-dark"
                density="compact">Consulter</v-btn></a>
          </td>
          <td>
            <a :href="item.champs.certificat_medical_xgtv" target="_blank"><v-btn elevation="0" color="primary-dark"
                density="compact">Consulter</v-btn></a>
          </td>
          <td>
            <v-btn variant="elevated" elevation="0" color="green-darken-4" density="compact" prepend-icon="mdi-check"
              class="mx-1" @click="show_confirm_valid_dialog(item.id)">Valider</v-btn>
          </td>
        </tr>
      </tbody>
    </v-table>
    <v-divider></v-divider>
    <div class="text-h6 mt-4">Documents manquants</div>
    <div>
      Il y a <b>{{ inscrits_to_validate.missing_doc.length }} participant(s)</b> n'ayant pas envoyé tous les documents.
    </div>
    <v-table density="compact" v-if="inscrits_to_validate.missing_doc.length > 0">
      <thead>
        <tr>
          <th class="text-left">Nom</th>
          <th class="text-left">Parcours</th>
          <th class="text-left">Fiche de renseignement médicale</th>
          <th class="text-left">CV Sportif</th>
          <th class="text-left">Certificat médical</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in inscrits_to_validate.missing_doc" :key="item.id">
          <td>{{ item.nom }} {{ item.prenom }}</td>
          <td>{{ item.course.nom.replace("Expérience Grande Traversée Volcanique", "XGTV") }}</td>
          <td>
            <a v-if="item.champs.fiche_medicale_xgtv" :href="item.champs.fiche_medicale_xgtv" target="_blank"><v-btn
                elevation="0" color="primary-dark" density="compact">Consulter</v-btn></a>
            <div v-else class="text-red-darken-4 font-weight-bold">Non envoyée</div>
          </td>
          <td>
            <a v-if="item.champs.cv_sportif_xgtv" :href="item.champs.cv_sportif_xgtv" target="_blank"><v-btn
                elevation="0" color="primary-dark" density="compact">Consulter</v-btn></a>
            <div v-else class="text-red-darken-4 font-weight-bold">Non envoyé</div>
          </td>
          <td>
            <a v-if="item.champs.certificat_medical_xgtv" :href="item.champs.certificat_medical_xgtv"
              target="_blank"><v-btn elevation="0" color="primary-dark" density="compact">Consulter</v-btn></a>
            <div v-else class="text-red-darken-4 font-weight-bold">Non envoyé</div>
          </td>
        </tr>
      </tbody>
    </v-table>
    <v-divider></v-divider>
    <div class="text-h6 mt-4">Déjà validé</div>
    <div>
      Vous avez déjà validé <b>{{ inscrits_to_validate.validated.length }} participant(s)</b>.
    </div>
    <v-table density="compact" v-if="inscrits_to_validate.validated.length > 0">
      <thead>
        <tr>
          <th class="text-left">Nom</th>
          <th class="text-left">Parcours</th>
          <th class="text-left">Fiche de renseignement médicale</th>
          <th class="text-left">CV Sportif</th>
          <th class="text-left">Certificat médical</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in inscrits_to_validate.validated" :key="item.id">
          <td>{{ item.nom }} {{ item.prenom }}</td>
          <td>{{ item.course.nom.replace("Expérience Grande Traversée Volcanique", "XGTV") }}</td>
          <td>
            <a v-if="item.champs.fiche_medicale_xgtv" :href="item.champs.fiche_medicale_xgtv" target="_blank"><v-btn
                elevation="0" color="primary-dark" density="compact">Consulter</v-btn></a>
            <div v-else class="text-red-darken-4 font-weight-bold">Non envoyée</div>
          </td>
          <td>
            <a v-if="item.champs.cv_sportif_xgtv" :href="item.champs.cv_sportif_xgtv" target="_blank"><v-btn
                elevation="0" color="primary-dark" density="compact">Consulter</v-btn></a>
            <div v-else class="text-red-darken-4 font-weight-bold">Non envoyé</div>
          </td>
          <td>
            <a v-if="item.champs.certificat_medical_xgtv" :href="item.champs.certificat_medical_xgtv"
              target="_blank"><v-btn elevation="0" color="primary-dark" density="compact">Consulter</v-btn></a>
            <div v-else class="text-red-darken-4 font-weight-bold">Non envoyé</div>
          </td>
        </tr>
      </tbody>
    </v-table>

    <v-dialog v-model="show_confirm_valid" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-body-1">Voulez-vous vraiment <b>valider</b> ce participant ?</div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red-darken-4" @click="show_confirm_valid = false">Non</v-btn>
          <v-btn color="green-darken-4" @click="handle_valid">Oui</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import AdminService from "@/services/admin.service.js";
export default {
  data() {
    return {
      id_inscription_to_handle: null,
      show_confirm_reject: false,
      show_confirm_valid: false,
      inscrits: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
    inscrits_to_validate() {
      let inscrits = this.inscrits;
      return this.get_inscrits_to_validate(inscrits, this.mainStore.authAdmin.adminData.privilege);
    },
  },
  methods: {
    async handle_valid() {
      this.show_confirm_valid = false;
      let request = await AdminService.validateXGTVDocument(this.id_inscription_to_handle, this.mainStore.authAdmin.adminData.privilege);
      if (!request.error) {
        this.loadInscrits();
      }
    },

    show_confirm_valid_dialog(id_inscription) {
      this.id_inscription_to_handle = id_inscription;
      this.show_confirm_valid = true;
    },
    get_inscrits_to_validate(inscrits, privilege) {
      let sorted_inscrits = {
        to_validate: [],
        validated: [],
        missing_doc: [],
      };
      for (let i = 0; i < inscrits.length; i++) {
        const inscrit = inscrits[i];

        if (inscrit.champs.fiche_medicale_xgtv == "" || inscrit.champs.cv_sportif_xgtv == "" || inscrit.champs.certificat_medical_xgtv == "") {
          sorted_inscrits.missing_doc.push(inscrit);
          continue;
        }

        if (inscrit.champs[privilege + "_validation"] && inscrit.champs[privilege + "_validation"] == "1") {
          sorted_inscrits.validated.push(inscrit);
          continue;
        }
        sorted_inscrits.to_validate.push(inscrit);
      }
      return sorted_inscrits;
    },
    async loadInscrits() {
      let request = await AdminService.getXGTVInscritsForValidation();
      if (!request.error) {
        this.inscrits = request;
      }
    },
  },
  async created() {
    await this.loadInscrits();
  },
};
</script>

<style lang="scss" scoped></style>